module.exports = __webpack_public_path__ + "img/hr-sand-rock-medium-08.95a056b9.png";